import { contexts } from "@/developing/dev-data";

export function bulkImportComponent(path) {
  const components = {};
  for (let stage of contexts.stages) {
    const [k, v] = stage;
    components[k] = () => import("@/developing/" + path + "/" + v + ".vue");
  }
  return components;
}

export function loadComponents(componentNameArray, stages) {
  const components = {};
  for (let componentName of componentNameArray) {
    for (let stage of stages) {
      const [k,v] = stage;
      components[componentName + "-" + k] = () => import(`@/developing/views/pages/${componentName}/${v}.vue`)
    }
  }
  return components
}
